import * as exSelect from '../../../forms/select';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function read(ctx: Context): any {
    function start(): void {
        // Get options
        ctx.shared.state.data = ctx.shared.state.search.result ?? ctx.current.getOptions();

        // If there is no data
        if (!ctx.shared.state.data.length) {
            return;
        }

        //
        ctx.option.start();
    }

    function reset(): void {
        ctx.listing.clear();
        ctx.option.clear();

        start();
    }

    // ------------------------------------------------------------------------

    return {
        start,
        reset,
    };
}

// ----------------------------------------------------------------------------

export default read;
